import i18n from '@/i18n';

/** 图片空间来源：与入库字段 source / sourceType 一致；path / navId 用于详情页跳转工作台模块 */

const IPE_PATH = '/ipe';

/** @type {Array<{ value: string, label: string, path: string | null, navId: string | null, group?: string }>} */
export const IMAGE_SPACE_SOURCE_REGISTRY = [
  { value: 'upload', label: '本地上传', path: null, navId: null, group: 'upload' },
  { value: 'imageSpace', label: '图片空间上传', path: IPE_PATH, navId: 'imageSpace', group: 'upload' },
  { value: 'library', label: '素材库选用', path: IPE_PATH, navId: 'systemMaterialLibrary', group: 'library' },
  { value: 'official', label: '官方素材', path: IPE_PATH, navId: 'systemMaterialLibrary', group: 'library' },
  { value: 'systemMaterial', label: '系统素材库', path: IPE_PATH, navId: 'systemMaterialLibrary', group: 'library' },
  { value: 'materialHub', label: '素材中心', path: IPE_PATH, navId: 'systemMaterialLibrary', group: 'library' },
  { value: 'goods', label: '主图创作', path: IPE_PATH, navId: 'goods', group: 'feature' },
  { value: 'goods_composite', label: '主图创作·合成图', path: IPE_PATH, navId: 'goods', group: 'feature' },
  { value: 'podProductDesign', label: '商品设计', path: IPE_PATH, navId: 'podProductDesign', group: 'feature' },
  { value: 'podProductDesign_composite', label: '商品设计', path: IPE_PATH, navId: 'podProductDesign', group: 'feature' },
  { value: 'titles', label: '标题提取（历史）', path: IPE_PATH, navId: 'aiCopywriting', group: 'feature' },
  { value: 'videos', label: '图生视频', path: IPE_PATH, navId: 'videos', group: 'feature' },
  { value: 'textToVideo', label: '文生视频', path: IPE_PATH, navId: 'textToVideo', group: 'feature' },
  { value: 'videos_result', label: '图生视频·结果', path: IPE_PATH, navId: 'videos', group: 'feature' },
  { value: 'modelTryOn', label: '模特试衣', path: '/ipe/model-try-on', navId: 'modelTryOn', group: 'feature' },
  { value: 'imageCrop', label: '图案裁剪', path: '/ipe/image-crop', navId: 'imageCrop', group: 'feature' },
  { value: 'cropDetail', label: '图案裁剪', path: '/ipe/image-crop', navId: 'imageCrop', group: 'feature' },
  { value: 'imageEnhance', label: '超分提质', path: '/ipe/image-enhance', navId: 'imageEnhance', group: 'feature' },
  { value: 'imageEnhance_result', label: '超分提质·结果图', path: '/ipe/image-enhance', navId: 'imageEnhance', group: 'feature' },
  { value: 'smartCutout', label: '智能抠图', path: '/ipe/smart-cutout', navId: 'smartCutout', group: 'feature' },
  { value: 'smartCutout_result', label: '智能抠图·结果图', path: '/ipe/smart-cutout', navId: 'smartCutout', group: 'feature' },
  { value: 'stampExtract', label: '印花提取', path: '/ipe/stamp-extract', navId: 'stampExtract', group: 'feature' },
  { value: 'stampExtract_result', label: '印花提取·结果图', path: '/ipe/stamp-extract', navId: 'stampExtract', group: 'feature' },
  { value: 'imageFission', label: '图片裂变', path: IPE_PATH, navId: 'imageFission', group: 'feature' },
  { value: 'patternFission', label: '图案裂变', path: IPE_PATH, navId: 'patternFission', group: 'feature' },
  { value: 'img2img', label: '万能改图', path: IPE_PATH, navId: 'img2img', group: 'feature' },
  { value: 'aiOutpaint', label: 'AI扩图', path: IPE_PATH, navId: 'aiOutpaint', group: 'feature' },
  { value: 'aiTextToImage', label: '文生图', path: IPE_PATH, navId: 'aiTextToImage', group: 'feature' },
  { value: 'aiCopywriting', label: 'AI文案', path: IPE_PATH, navId: 'aiCopywriting', group: 'feature' },
  { value: 'infringementDetection', label: '侵权检测', path: IPE_PATH, navId: 'infringementDetection', group: 'feature' },
  { value: 'thirdPartyReceive', label: '第三方商品库', path: IPE_PATH, navId: 'thirdPartyReceive', group: 'feature' },
  { value: 'modelHandheld', label: '手持商品', path: IPE_PATH, navId: 'modelHandheld', group: 'feature' },
  { value: 'modelPoseFission', label: '姿势裂变', path: IPE_PATH, navId: 'modelPoseFission', group: 'feature' },
  { value: 'modelUniversalWear', label: '万物穿戴', path: IPE_PATH, navId: 'modelUniversalWear', group: 'feature' },
  { value: 'aigc', label: 'AI 生成', path: IPE_PATH, navId: 'img2img', group: 'feature' },
  { value: 'agent', label: 'Agent 生图', path: '/ipe/agent-chat', navId: null, group: 'feature' },
  { value: 'sourcing', label: '插件采集', path: IPE_PATH, navId: 'sourcingHub', group: 'collection' },
  { value: 'materialCrawlerUser', label: '用户采集', path: IPE_PATH, navId: 'systemMaterialLibrary', group: 'collection' },
  { value: 'materialCrawlerScheduled', label: '定时采集', path: IPE_PATH, navId: 'systemMaterialLibrary', group: 'collection' },
  { value: 'workflow', label: '工作流任务', path: IPE_PATH, navId: 'ipeWorkflow', group: 'workflow' },
  { value: 'workflow-batch', label: '工作流·批量采集', path: IPE_PATH, navId: 'ipeWorkflow', group: 'workflow' },
  { value: 'workflow_platform_listing', label: '工作流·平台刊登', path: IPE_PATH, navId: 'platformListing', group: 'workflow' },
];

const SOURCE_GROUP_LABELS = {
  upload: 'groupUpload',
  feature: 'groupFeature',
  collection: 'groupCollection',
  library: 'groupLibrary',
  workflow: 'groupWorkflow',
};

/** 来源值 → i18n key（imageSource 组） */
export function getImageSpaceSourceLabel(sourceKey, fallbackLabel = '') {
  const key = String(sourceKey || '').trim();
  if (!key) return fallbackLabel;
  return i18n.t(`workbench:imageSource.${key}`, { defaultValue: fallbackLabel || key });
}

/** 别名 → 标准 source 值（兼容历史字段、后端 sourceType） */
const IMAGE_SPACE_SOURCE_ALIASES = {
  goods_composite: 'goods_composite',
  'goods-composite': 'goods_composite',
  'workflow-batch': 'workflow-batch',
  workflow_platform_listing: 'workflow_platform_listing',
  'workflow-platform-listing': 'workflow_platform_listing',
  patternFission: 'patternFission',
  materialHub: 'materialHub',
  cropDetail: 'cropDetail',
  stampExtract_result: 'stampExtract_result',
  imageEnhance_result: 'imageEnhance_result',
  smartCutout_result: 'smartCutout_result',
  aiOutpaint: 'aiOutpaint',
  aiTextToImage: 'aiTextToImage',
  modelHandheld: 'modelHandheld',
  modelPoseFission: 'modelPoseFission',
  modelUniversalWear: 'modelUniversalWear',
  podImageClarity: 'imageEnhance',
  podProductDesign: 'podProductDesign',
  podProductDesign_composite: 'podProductDesign_composite',
  'pod-product-design': 'podProductDesign',
  aigc: 'aigc',
  imageSpaceUpload: 'imageSpace',
  local: 'upload',
  manual: 'upload',
  '本地上传': 'upload',
  '按模版导出': 'goods',
  '工作流导出': 'workflow',
};

const REGISTRY_BY_VALUE = new Map(
  IMAGE_SPACE_SOURCE_REGISTRY.map((item) => [item.value, item]),
);

export const IMAGE_SPACE_SOURCE_OPTIONS = [
  { value: '', label: '全部', path: null, navId: null },
  ...IMAGE_SPACE_SOURCE_REGISTRY.filter(
    (item, index, list) => list.findIndex((x) => x.value === item.value) === index,
  ),
];

/** 图片空间弹窗「来源」：仅当前系统可生成图片/视频的 AI 模块 */
export const IMAGE_SPACE_GENERATION_SOURCE_KEYS = [
  'goods',
  'goods_composite',
  'podProductDesign',
  'podProductDesign_composite',
  'imageCrop',
  'imageEnhance',
  'imageEnhance_result',
  'smartCutout',
  'smartCutout_result',
  'stampExtract',
  'stampExtract_result',
  'imageFission',
  'patternFission',
  'img2img',
  'aigc',
  'aiOutpaint',
  'aiTextToImage',
  'videos',
  'videos_result',
  'textToVideo',
  'modelTryOn',
  'modelHandheld',
  'modelPoseFission',
  'modelUniversalWear',
  'agent',
];

export const IMAGE_SPACE_LIBRARY_MODAL_SOURCE_OPTIONS = [
  { value: '', label: '全部', path: null, navId: null },
  ...IMAGE_SPACE_GENERATION_SOURCE_KEYS.map((value) => REGISTRY_BY_VALUE.get(value)).filter(Boolean),
];

/** 素材库弹窗「来源」下拉：按当前语言渲染 label */
export function buildImageSpaceLibraryModalSourceOptions() {
  return IMAGE_SPACE_LIBRARY_MODAL_SOURCE_OPTIONS.map((opt) => ({
    value: opt.value,
    label: opt.value
      ? getImageSpaceSourceLabel(opt.value, opt.label)
      : i18n.t('workbench:imageSource.all'),
  }));
}

/** 请求列表筛选时允许的 source 值（不含「全部」） */
export const IMAGE_SPACE_SOURCE_FILTER_KEYS = IMAGE_SPACE_SOURCE_OPTIONS.filter((o) => o.value).map(
  (o) => o.value,
);

function pickFirstNonEmptyString(...values) {
  for (const value of values) {
    if (value == null || value === '') continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return '';
}

/**
 * 归一化 source 键（兼容别名、大小写）
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeImageSpaceSourceKey(raw) {
  const text = pickFirstNonEmptyString(raw);
  if (!text) return '';
  const alias = IMAGE_SPACE_SOURCE_ALIASES[text];
  if (alias) return alias;
  if (REGISTRY_BY_VALUE.has(text)) return text;
  const lower = text.toLowerCase();
  for (const [key] of REGISTRY_BY_VALUE.entries()) {
    if (key.toLowerCase() === lower) return key;
  }
  return text;
}

/**
 * 从图片记录解析来源键（source / sourceType / origin 等）
 * @param {Record<string, unknown> | string | null | undefined} imageOrSource
 * @returns {string}
 */
export function resolveImageSpaceSourceKey(imageOrSource) {
  if (imageOrSource == null) return 'upload';
  if (typeof imageOrSource === 'string') {
    return normalizeImageSpaceSourceKey(imageOrSource) || 'upload';
  }
  const raw = pickFirstNonEmptyString(
    imageOrSource.source,
    imageOrSource.sourceType,
    imageOrSource.origin,
    imageOrSource.taskType,
    imageOrSource.module,
    imageOrSource.navId,
  );
  return normalizeImageSpaceSourceKey(raw) || 'upload';
}

function resolveSourceRegistryEntry(sourceKey) {
  const direct = REGISTRY_BY_VALUE.get(sourceKey);
  if (direct) return { opt: direct, resultSuffix: false };
  if (typeof sourceKey === 'string' && sourceKey.endsWith('_result')) {
    const baseKey = sourceKey.slice(0, -'_result'.length);
    const base = REGISTRY_BY_VALUE.get(baseKey);
    if (base) return { opt: base, resultSuffix: true };
  }
  return { opt: null, resultSuffix: false };
}

/**
 * @param {string | Record<string, unknown> | null | undefined} sourceOrImage
 * @returns {{ label: string, path: string | null, navId: string | null, group: string | null, groupLabel: string | null, sourceKey: string }}
 */
export function getImageSpaceSourceMeta(sourceOrImage) {
  const sourceKey = resolveImageSpaceSourceKey(sourceOrImage);
  const { opt, resultSuffix } = resolveSourceRegistryEntry(sourceKey);
  if (opt) {
    const baseLabel = getImageSpaceSourceLabel(opt.value, opt.label);
    return {
      label: resultSuffix
        ? i18n.t('workbench:imageSource.resultSuffix', { label: baseLabel })
        : baseLabel,
      path: opt.path ?? null,
      navId: opt.navId ?? null,
      group: opt.group ?? null,
      groupLabel: opt.group
        ? i18n.t(`workbench:imageSource.${SOURCE_GROUP_LABELS[opt.group] ?? 'groupFeature'}`)
        : null,
      sourceKey,
    };
  }
  return {
    label: sourceKey || '—',
    path: null,
    navId: null,
    group: null,
    groupLabel: null,
    sourceKey: sourceKey || '',
  };
}

/**
 * 来源补充说明（批次号、任务号、分类等）
 * @param {Record<string, unknown> | null | undefined} image
 * @returns {string | null}
 */
export function resolveImageSpaceSourceDetail(image) {
  if (!image || typeof image !== 'object') return null;
  const parts = [];
  const category = pickFirstNonEmptyString(image.category, image.sourceCategory, image.batchCategory);
  if (category) parts.push(category);

  const taskId = pickFirstNonEmptyString(
    image.sourceTaskId,
    image.taskId,
    image.parentTaskId,
    image.relatedTaskId,
  );
  if (taskId) parts.push(i18n.t('workbench:imageSource.taskDetail', { id: taskId }));

  const batchId = pickFirstNonEmptyString(
    image.fissionBatchId,
    image.materialBatchId,
    image.batchId,
    image.sourceBatchId,
  );
  if (batchId) parts.push(i18n.t('workbench:imageSource.batchDetail', { id: batchId }));

  const parentId = pickFirstNonEmptyString(image.parentSourceId, image.parentImageId, image.originImageId);
  if (parentId && !taskId) parts.push(i18n.t('workbench:imageSource.parentDetail', { id: parentId }));

  if (parts.length === 0) return null;
  return parts.join(' · ');
}
